import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Heading } from 'components';
import './List.scss';

class List extends Component {
  renderItems = data =>
    data.map(item => <li className={'list__item'}>{item.skill}</li>);

  render() {
    const { data, title } = this.props;

    return (
      <div className={'list__container'}>
        <Heading size={'regular'} type={3}>
          {title}
        </Heading>
        <ul className={'list__content'}>{this.renderItems(data)}</ul>
      </div>
    );
  }
}

List.propTypes = {
  title: PropTypes.string.isRequired,
};

export default List;
